"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _scrollbar = _interopRequireDefault(require("promo-js/lib/scrollbar"));

const ThinScrollbar = props => {
  const {
    children,
    className
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "className"]);
  return /*#__PURE__*/_react.default.createElement(_scrollbar.default, (0, _extends2.default)({
    className: (0, _classnames.default)('thin-scrollbar', className)
  }, otherProps), children);
};

ThinScrollbar.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
ThinScrollbar.defaultProps = {
  children: null,
  className: ''
};
var _default = ThinScrollbar;
exports.default = _default;